<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 44C12.9 44 11.9583 43.6083 11.175 42.825C10.3917 42.0417 10 41.1 10 40V24C10 21.1667 10.7417 18.6333 12.225 16.4C13.7083 14.1667 15.6333 12.5 18 11.4V10C18 8.33333 18.5833 6.91667 19.75 5.75C20.9167 4.58333 22.3333 4 24 4C25.6667 4 27.0833 4.58333 28.25 5.75C29.4167 6.91667 30 8.33333 30 10V11.4C32.3667 12.5 34.2917 14.1667 35.775 16.4C37.2583 18.6333 38 21.1667 38 24V40C38 41.1 37.6083 42.0417 36.825 42.825C36.0417 43.6083 35.1 44 34 44H14ZM14 40H34V24C34 21.2333 33.025 18.875 31.075 16.925C29.125 14.975 26.7667 14 24 14C21.2333 14 18.875 14.975 16.925 16.925C14.975 18.875 14 21.2333 14 24V40ZM30 32C30.5667 32 31.0417 31.8083 31.425 31.425C31.8083 31.0417 32 30.5667 32 30V24H16V28H28V30C28 30.5667 28.1917 31.0417 28.575 31.425C28.9583 31.8083 29.4333 32 30 32ZM22 10.2C22.3667 10.1333 22.7 10.0833 23 10.05C23.3 10.0167 23.6333 10 24 10C24.3667 10 24.7 10.0167 25 10.05C25.3 10.0833 25.6333 10.1333 26 10.2V10C26 9.43333 25.8083 8.95833 25.425 8.575C25.0417 8.19167 24.5667 8 24 8C23.4333 8 22.9583 8.19167 22.575 8.575C22.1917 8.95833 22 9.43333 22 10V10.2Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
